import {
  GET_ALL_TAGS,
  GET_ALL_RAMAIS,
  GET_ALL_CENTRO_DE_CUSTOS,
  GET_DADOS_RELATORIO,
  GET_ALL_CONFERENCIAS,
} from './mutation-types'
import relatorioChamadasHttpService from '../_services/relatorioChamadasHttpService'

export default {
  listarTags: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.listarTags()
      if (response.data.length > 0) {
        commit(GET_ALL_TAGS, response.data)
      }
    } catch (e) {
      console.log(e.message)
    }
  },
  listarRamais: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.listarRamais()
      if (response.data.ramais) {
        commit(GET_ALL_RAMAIS, response.data.ramais)
      } else {
        commit(GET_ALL_RAMAIS, response.data)
      }
    } catch (e) {
      console.log(e.message)
    }
  },
  listarCentroDeCustos: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.listarCentroDeCustos()
      if (response.data.length > 0) {
        commit(GET_ALL_CENTRO_DE_CUSTOS, response.data)
      }
    } catch (e) {
      console.log(e.message)
    }
  },
  listarConferencias: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.listarConferencias()
      if (response.data.length > 0) {
        commit(GET_ALL_CONFERENCIAS, response.data)
      }
    } catch (e) {
      console.log(e.message)
    }
  },
  gerarDadosRelatorio: async ({ commit }, { form, page }) => {
    try {
      const response = await relatorioChamadasHttpService.buscarDadosRelatorio(form, page)
      commit(GET_DADOS_RELATORIO, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
